import React from 'react';
import ReactDOM from 'react-dom';
import { useLaunchConfig } from '../../hooks/useLaunchConfig';
import './ImportOptionsModal.css';

// SHEYOU Logo URL
const SHEYOU_LOGO = 'https://res.cloudinary.com/sheyou/image/upload/v1769616249/logo_739166a408.png';

const ImportOptionsModal = ({
  open,
  onClose,
  onBrowseCommunity,
  onOpenExplore,
  onOpenEmailModal,
  onOpenExtensionModal,
  onOpenUrlImportModal
}) => {
  const isNativeApp = typeof window !== 'undefined' && window.ReactNativeWebView !== undefined;
  const { isEmailEnabled, isLinkEnabled, isMarketplaceImportEnabled } = useLaunchConfig();

  if (!open) return null;

  const modalContent = (
    <div className="import-options-modal-overlay" onClick={onClose}>
      <div className="import-options-modal-container" onClick={e => e.stopPropagation()}>
        <div className="import-options-close-icon" onClick={onClose}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </div>
        <div className="import-options-header">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#00b5ad" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px' }}>
            <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
            <line x1="3" y1="6" x2="21" y2="6"></line>
            <path d="M16 10a4 4 0 0 1-8 0"></path>
          </svg>
          <h3>Import Clothing</h3>
        </div>
        <div className="clothing-modal-content">
          <div className="import-options-grid">

            {/* Community Option. Deliberately ungated: when every other import
                route is switched off in launch config, this modal is otherwise
                a dead end for someone who has nothing in their closet yet.
                It also stays inside the app, unlike the marketplace link. */}
            {onBrowseCommunity && (
              <div
                className="import-option-card"
                onClick={() => {
                  onClose();
                  onBrowseCommunity();
                }}
                role="button"
                tabIndex={0}
              >
                <div className="import-option-content">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#00b5ad" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="11" cy="11" r="8" />
                    <line x1="21" y1="21" x2="16.65" y2="16.65" />
                  </svg>
                  <span className="import-option-text">Community</span>
                  <span className="import-option-subtext">Try on designer pieces and shared looks</span>
                </div>
              </div>
            )}

            {/* Explore Option */}
            {isMarketplaceImportEnabled && (
              <div
                className="import-option-card"
                onClick={() => {
                  onClose();
                  if (onOpenExplore) onOpenExplore();
                }}
                role="button"
                tabIndex={0}
              >
                <div className="import-option-content">
                  <img src={SHEYOU_LOGO} alt="SHEYOU" className="sheyou-logo" />
                  <span className="import-option-text">Explore</span>
                  <span className="import-option-subtext">Discover SHEYOU marketplace</span>
                </div>
              </div>
            )}

            {/* Email Import Option */}
            {isEmailEnabled && (
              <div
                className="import-option-card"
                onClick={() => {
                  onClose();
                  if (onOpenEmailModal) onOpenEmailModal();
                }}
                role="button"
                tabIndex={0}
              >
                <div className="import-option-content">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#00b5ad" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="4" width="20" height="16" rx="2" />
                    <path d="M22 4L12 13L2 4" />
                  </svg>
                  <span className="import-option-text">Email</span>
                  <span className="import-option-subtext">Import from order confirmations</span>
                </div>
              </div>
            )}

            {/* Browser Extension or Share Option */}
            {isNativeApp ? (
              <div
                className="import-option-card"
                onClick={() => {
                  onClose();
                  alert('Tutorial: Open any browser or app, tap the Share icon, and select SUSU Closet to import items!');
                }}
                role="button"
                tabIndex={0}
              >
                <div className="import-option-content">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#00b5ad" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                    <polyline points="16 6 12 2 8 6" />
                    <line x1="12" y1="2" x2="12" y2="15" />
                  </svg>
                  <span className="import-option-text">Share to App</span>
                  <span className="import-option-subtext">Import from any app via Share menu</span>
                </div>
              </div>
            ) : (
              <div
                className="import-option-card"
                onClick={() => {
                  onClose();
                  if (onOpenExtensionModal) onOpenExtensionModal();
                }}
                role="button"
                tabIndex={0}
              >
                <div className="import-option-content">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#00b5ad" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="3" width="20" height="14" rx="2" />
                    <path d="M8 21h8" />
                    <path d="M12 17v4" />
                    <path d="M7 10h4" />
                    <path d="M9 8v4" />
                  </svg>
                  <span className="import-option-text">Browser</span>
                  <span className="import-option-subtext">Save from any website</span>
                </div>
              </div>
            )}

            {/* URL Import Option */}
            {isLinkEnabled && (
              <div
                className="import-option-card"
                onClick={() => {
                  onClose();
                  if (onOpenUrlImportModal) onOpenUrlImportModal();
                }}
                role="button"
                tabIndex={0}
              >
                <div className="import-option-content">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#00b5ad" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
                    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
                  </svg>
                  <span className="import-option-text">Link</span>
                  <span className="import-option-subtext">Import from URL</span>
                </div>
              </div>
            )}

          </div>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default ImportOptionsModal;
